import { useTranslation } from 'react-i18next';
import { RightContent } from '../styles';
import Card from '@/components/Card';
import Typography from '@mui/material/Typography';
import ERP from './ERP';
import DataDisplay from './DataDisplay';
import { useEffect } from 'react';

function Customer({
  modeView,
  customerData,
}: {
  modeView: string;
  customerData: CustomerDataType;
}) {
  const { t } = useTranslation();

  useEffect(() => {
    console.log('Customer data updated:', customerData);
  }, [customerData]);

  return (
    <RightContent>
      {/** ERP Section with conections data */}
      <Card padding="24px" sx={{ gap: '16px' }}>
        <Typography variant="h3">
          {t('equipment.customer.conectionData')}
        </Typography>
        <ERP modeView={modeView} customerData={customerData} />
      </Card>

      {/** Customer Data Section */}
      <Card padding="24px" sx={{ gap: '16px' }}>
        <Typography variant="h3">
          {t('equipment.customer.customerData.title')}
        </Typography>
        <DataDisplay modeView={modeView} customerData={customerData} />
      </Card>
    </RightContent>
  );
}

export default Customer;
